import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import { hasToken } from '@/utils/auth'
import MainLayout from '../views/MainLayout.vue'
import HomeView from '../views/HomeView.vue'

// 导入子模块路由
import easyApisRoutes from '../modules/EasyApis/router'
import textProcessRoutes from '../modules/TextProcess/router'

/**
 * 主路由配置
 * 采用嵌套路由结构，所有页面都包裹在 MainLayout 中
 */
const routes: Array<RouteRecordRaw> = [
  {
    // 根路径，使用 MainLayout 作为容器
    path: '/',
    component: MainLayout,
    children: [
      {
        // 首页 - 项目导航页
        path: '',
        name: 'Home',
        component: HomeView,
        meta: {
          title: '首页'
        }
      },
      {
        // EasyApis 模块路由（包含所有子路由）
        path: 'easyapis',
        name: 'EasyApis',
        children: easyApisRoutes,
        meta: {
          title: 'EasyApis'
        }
      },
      {
        // 文本处理模块路由（包含所有子路由）
        path: 'textprocess',
        name: 'TextProcess',
        children: textProcessRoutes,
        meta: {
          title: '文本处理'
        }
      },
      // 未来可以在这里添加更多模块路由
      // {
      //   path: 'other-project',
      //   name: 'OtherProject',
      //   children: otherProjectRoutes,
      //   meta: {
      //     title: '其他项目'
      //   }
      // }
    ]
  },
  {
    // 404 页面（可选）
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('../views/NotFound.vue'),
    meta: {
      title: '页面不存在'
    }
  }
]

// 创建路由实例
const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// 路由守卫 - 可以在这里添加权限验证、页面标题设置等
router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta.title) {
    document.title = `${to.meta.title} - 导航中心`
  } else {
    document.title = '导航中心'
  }

  // 记账模块需要访问密码。
  // 这里只看本地有没有令牌，是为了少弹一次密码框；
  // 真正的校验在后端，没有有效令牌接口一律 401，所以改这段代码绕不过去。
  if (to.meta.requiresJiZhangAuth && !hasToken()) {
    next({
      path: '/easyapis/jizhang/unlock',
      query: { redirect: to.fullPath }
    })
    return
  }

  next()
})

export default router
